/**
 * Provides utility functions for permissions
 */
export class PermissionHelperService {
  constructor(private catalogueStatusConstants: InterACT.Interfaces.ICatalogueStatusConstants) { }

  /**
   * Provides permission set for the catalogue
   * @param catalogue the catalogue to grant permissions for
   * @returns a set of catalogue permissions
   */
  public getPermissionsForCatalogue(catalogue: InterACT.Interfaces.Catalogues.Catalogue) {
    const status = catalogue.status.toUpperCase();
    return <InterACT.Interfaces.ICataloguePermissions>{
      canCreateDraft: [
        this.catalogueStatusConstants.LIVE,
        this.catalogueStatusConstants.EXPIRED,
        this.catalogueStatusConstants.AUTHORISED
      ].indexOf(status) > -1,
      canUpdateStatus: [
        this.catalogueStatusConstants.DRAFT,
        this.catalogueStatusConstants.AWAITING_AUTHORISATION
      ].indexOf(status) > -1,
      canEdit: status === this.catalogueStatusConstants.DRAFT
    };
  }

  /**
   * Provides permission set for the catalogue product variants
   * @param catalogue the catalogue to grant product variant permissions to
   * @returns a set of product variant permissions
   */
  public getPermissionsForProductsVariants(catalogue: InterACT.Interfaces.Catalogues.Catalogue) {
    const status = catalogue.status.toUpperCase();
    return <InterACT.Interfaces.IProductVariantPermissions>{
      canEdit: status === this.catalogueStatusConstants.DRAFT,
      canCopy: status === this.catalogueStatusConstants.DRAFT,
      canCreate: status === this.catalogueStatusConstants.DRAFT
    };
  }
}